export default __webpack_public_path__ + "images/a238c36830a0539e17f06e1dcdc97869.png";